/**
 * Tariff List - Accordion with exclusive open behavior (only one open at a time)
 */
function smoothScrollTo(startY, targetY, duration) {
    const diff = targetY - startY;
    let startTime = null;

    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const ease = progress < 0.5
            ? 2 * progress * progress
            : -1 + (4 - 2 * progress) * progress;
        document.body.scrollTo(0, startY + diff * ease);
        if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mod24Tarife').forEach(container => {
        const tariffs = container.querySelectorAll('.tarif');

        tariffs.forEach(tarif => {
            const header = tarif.querySelector('.tarif__header');
            if (!header) return;

            header.addEventListener('click', (e) => {
                // Don't toggle on desktop
                if (window.innerWidth >= 768) return;

                // Don't toggle if clicking on tooltip
                if (e.target.closest('.c24-tooltip-wrapper, .c24Tooltip, a')) return;

                const isOpen = tarif.classList.contains('is-open');

                // Close all other accordions
                tariffs.forEach(other => {
                    other.classList.remove('is-open');
                });

                // Toggle current (open if it was closed)
                if (!isOpen) {
                    tarif.classList.add('is-open');
                    setTimeout(() => {
                        const startY = document.body.scrollTop;
                        const targetY = startY + tarif.getBoundingClientRect().top;
                        smoothScrollTo(startY, targetY, 400);
                    }, 150);
                }
            });
        });
    });
});
